import React, { forwardRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import MPInput, { MPInputProps } from './Input';

export type PasswordInputProps = Omit<MPInputProps, 'type'>;

const MPPasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({
  label = 'Contraseña',
  ...rest
}, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="mp-tw-relative mp-tw-w-full">
      <MPInput
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        label={label}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setIsVisible(!isVisible)}
        className={[
          'mp-tw-absolute mp-tw-right-3',
          'mp-tw-bg-transparent mp-tw-border-none mp-tw-cursor-pointer',
          'mp-tw-text-mp-text-muted mp-tw-p-1',
          'mp-tw-flex mp-tw-items-center mp-tw-justify-center',
          'mp-tw-transition-colors mp-tw-duration-mp-normal',
          'hover:mp-tw-text-mp-orange',
          'focus:mp-tw-outline-none',
          // Position at bottom of input area (accounting for label)
          label ? 'mp-tw-bottom-3' : 'mp-tw-top-1/2 mp-tw--translate-y-1/2',
        ].join(' ')}
        aria-label={isVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        tabIndex={-1}
      >
        <FontAwesomeIcon icon={isVisible ? faEyeSlash : faEye} />
      </button>
    </div>
  );
});

MPPasswordInput.displayName = 'MPPasswordInput';

export default MPPasswordInput;
